<template>
    <Dialog :containerStyle="{width: mobile ? '85vw' : '35vw'}" :visible.sync="display" modal @hide="closeDialog()">
        <template #header>
            {{ $t('AppOperationExportRequestDialog.Exportar dados de operação') }}
        </template>

        <div class="d-flex flex-column mx-4">
            <label for="fileName">{{ $t('AppOperationExportRequestDialog.Nome do arquivo') }}</label>
            <InputText id="fileName" v-model.trim="fileName" :class="{'p-invalid': invalidField}"
                       @input="invalidField = false"></InputText>
            <small v-if="invalidField" style="color: red">
                {{ $t('AppOperationExportRequestDialog.Campo obrigatório') }}
            </small>
        </div>

        <div class="mt-4 mx-5 text-justify">
            {{
                $t('AppOperationExportRequestDialog.Atenção Ao clicar em Exportar dados, o arquivo será gerado apenas com os dados existentes até o momento')
            }}
        </div>

        <template #footer>
            <Button @click="requestExport" :label="$t('AppOperationExportRequestDialog.Exportar dados')"/>
        </template>
    </Dialog>
</template>

<script>
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import {OPERATIONS_LIST} from "@/components/views/agriculture/AppAgricultureOptions";
import dateFormat from "@/mixins/DateMixin";
import dateHourFormat from "@/mixins/DateMixin";

export default {
    mixins: [dateFormat, dateHourFormat],
    data() {
        return {
            display: false,
            invalidField: false,
            fileName: null
        }
    },
    props: {
        operation: {
            type: Object,
            required: true
        },
        field: {
            type: Object,
            required: true
        },
        showDialog: {
            type: Boolean,
            default: false
        },
        mobile: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        closeDialog() {
            this.display = false;
            this.fileName = null;
            this.$emit('hideDialog');
        },
        requestExport() {
            if (!this.fileName) {
                this.invalidField = true
                return;
            }

            this.$emit('requestExport', this.fileName);
        },
        generateStandardFileName() {
            let fieldName = this.field.name
            let opType = this.formatToFileName(this.operation.operation_type)
            let fStartDate = this.dateFormat(this.operation.start.valueOf() / 1000, 'GMT').replaceAll("/", "")
            let fEndDate = this.dateFormat(this.operation.end.valueOf() / 1000, 'GMT').replaceAll("/", "")
            let cDateHour = this.dateHourFormat(Date.now() / 1000)
            let cHour = cDateHour.split(' ')[1].replaceAll(":", "");
            return `${fieldName}_${opType}_${fStartDate}_${fEndDate}_${cHour}`
        },
        formatToFileName(operationType) {
            let label = this.parseOperationType(operationType)
            // Removendo acentos e deixando em caixa alta
            return label.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toUpperCase()
        },
        parseOperationType(operationType) {
            if (!operationType) {
                return
            }
            return OPERATIONS_LIST().find(op => op.name === operationType).label
        }
    },
    watch: {
        showDialog: function (val) {
            this.display = val;
            if (val) {
                this.fileName = this.generateStandardFileName();
            }
        }
    },
    components: {
        InputText, Button, Dialog
    }
}
</script>

<style scoped>

</style>
